import React from "react";
import { Link } from "react-router-dom";
import smiklogo from "../../assets/icons/Logo001.png";

const TopBarLogo = () => (
  <Link className="flex items-center gap-2 select-none group no-underline" to="/">
    <img
      src={smiklogo}
      alt="smiklearn Logo"
      className="w-10 h-10 object-contain group-hover:scale-105 transition-all duration-300"
    />
    <span className="font-black text-xl tracking-tight text-[#264b82] group-hover:text-blue-600 transition-colors duration-300">
      Yuvasakthi Academy
    </span>
  </Link>
);

export default TopBarLogo;